import { Button, CircularProgress, Stack } from "@mui/material";

import type { ScoutConversationPrivateDocumentRow } from "../hooks/useScoutConversationPrivateDocuments";

type Props = {
  documents: ScoutConversationPrivateDocumentRow[];
  isConfirming: boolean;
  isDeclining?: boolean;
  onConfirm: (privateDocumentIds: string[]) => void;
  onDecline?: () => void;
};

export function ScoutLargeDocumentOptInButtons({
  documents,
  isConfirming,
  isDeclining = false,
  onConfirm,
  onDecline,
}: Props) {
  const privateDocumentIds = documents.map((document) => document.id);
  if (privateDocumentIds.length === 0) {
    return null;
  }

  const isBusy = isConfirming || isDeclining;
  const isMultiDocument = privateDocumentIds.length > 1;

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1}
      sx={{
        width: "100%",
        maxWidth: 920,
        mx: "auto",
        justifyContent: "flex-end",
        mb: 2,
      }}
    >
      {onDecline ? (
        <Button disabled={isBusy} onClick={onDecline}>
          Decline
        </Button>
      ) : null}
      <Button
        variant="contained"
        disabled={isBusy}
        onClick={() => onConfirm(privateDocumentIds)}
        startIcon={isConfirming ? <CircularProgress size={16} color="inherit" /> : undefined}
      >
        {isMultiDocument
          ? `Start full analysis for ${privateDocumentIds.length} files`
          : "Start full analysis"}
      </Button>
    </Stack>
  );
}
